/**
 * GridPercentSign
 * Render a small percent-sign in DataGridCell
 */
export function GridPercentSign() {
    return <span className="px-0.5">%</span>;
}
